(() => {
  const params = new URLSearchParams(window.location.search);
  const discountCode = params.get('sp_discount');
  const locale = (document.documentElement.lang || window.Shopify?.locale || '')
    .toLowerCase()
    .split('-')[0];
  const expectedDiscountCode = locale === 'en' ? 'WELCOME5' : 'WELKOM5';

  // Alleen de welkomstcode voor de actieve storefronttaal mag via deze
  // storefront-link worden toegepast. Andere querywaarden worden genegeerd.
  if (discountCode !== expectedDiscountCode) return;

  const storageKey = 'sp-email-discount-applied';
  try {
    if (window.sessionStorage.getItem(storageKey) === discountCode) {
      document.documentElement.dataset.spEmailDiscount = 'applied';
      return;
    }
  } catch (error) {
    // De korting kan ook zonder sessionStorage veilig via de cart-API worden gezet.
  }

  const routesRoot = window.Shopify?.routes?.root || '/';
  fetch(`${routesRoot}cart/update.js`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ discount: discountCode }),
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Discount update failed with ${response.status}`);
      return response.json();
    })
    .then(() => {
      try {
        window.sessionStorage.setItem(storageKey, discountCode);
      } catch (error) {
        // Geen functionele blokkade: Shopify heeft de cartsessie al bijgewerkt.
      }
      document.documentElement.dataset.spEmailDiscount = 'applied';
    })
    .catch(() => {
      document.documentElement.dataset.spEmailDiscount = 'failed';
    });
})();
